import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PendingEvidenceViewerDialogComponent } from './pending-evidence-viewer.dialog';
import { TransactionsService } from '../../services/transactions.service';

@Injectable({
  providedIn: 'root'
})
export class PendingEvidenceViewerDialogService {

    public confirmEvidence: boolean = false;

    constructor(
        public dialog: MatDialog,
        public transactionService: TransactionsService) {}

    public open(evidence: string, pendingEvidenceList, index, callback: any) {
        let dialog = this.dialog.open(PendingEvidenceViewerDialogComponent, {
            width: '100%',
            maxWidth: '80vw',
            maxHeight: '97vh',
            height: '100%',
            data: {
                pendingEvidence: evidence,
                pendingEvidenceList,
                index
            }
        });

        dialog.afterClosed().subscribe(r => {
            callback();
        })
    }
}
